import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonHeaderComponent } from '../headers/common-header/common-header.component';
import { ApplicationHeaderComponent } from '../headers/application-header/application-header.component';
import { LearningHeaderComponent } from '../headers/learning-header/learning-header.component';
import { IonicModule } from '@ionic/angular';
import { HomeNavigationComponent } from '../footers/home-navigation/home-navigation.component';
import { RouterModule } from '@angular/router';
import { SubjectHeaderComponent } from '../headers/subject-header/subject-header.component';
import { BottomButtonsComponent } from '../footers/bottom-buttons/bottom-buttons.component';
import { FormsModule } from '@angular/forms';
import { InputErrorComponent } from '../input-error/input-error.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MobileLayoutComponent } from '../mobile-layout/mobile-layout.component';
import { FlowProgressComponent } from '../flow-progress/flow-progress.component';
import { LayoutComponent } from '../layout/layout.component';
import { FlowProgressLayoutComponent } from '../flow-progress-layout/flow-progress-layout.component';
import { MenuBlockComponent } from '../menu-block/menu-block.component';
import { MenuBlockWrapperComponent } from '../menu-block-wrapper/menu-block.component';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';
import { ReflectionLayoutComponent } from '../reflection-layout/reflection-layout.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
    ],
    declarations: [
        CommonHeaderComponent,
        ApplicationHeaderComponent,
        LearningHeaderComponent,
        HomeNavigationComponent,
        SubjectHeaderComponent,
        BottomButtonsComponent,
        InputErrorComponent,
        ProgressBarComponent,
        MobileLayoutComponent,
        FlowProgressComponent,
        LayoutComponent,
        FlowProgressLayoutComponent,
        MenuBlockComponent,
        MenuBlockWrapperComponent,
        BreadcrumbsComponent,
        ReflectionLayoutComponent
    ],
    exports: [
        CommonHeaderComponent,
        ApplicationHeaderComponent,
        LearningHeaderComponent,
        HomeNavigationComponent,
        SubjectHeaderComponent,
        BottomButtonsComponent,
        InputErrorComponent,
        ProgressBarComponent,
        MobileLayoutComponent,
        FlowProgressComponent,
        LayoutComponent,
        FlowProgressLayoutComponent,
        MenuBlockComponent,
        MenuBlockWrapperComponent,
        BreadcrumbsComponent,
        ReflectionLayoutComponent
    ]
})
export class SharedModule { }
